import { useSelector } from 'react-redux';
import { selectDefaultCreationEnvironment } from '../../pages/environments/environmentsReducer';
import { DownloadAsCsvButton } from '../shared/csv/DownloadAsCsvButton';
import { getCsvHeaders } from '../shared/csv/utils';
import { TagRow } from './types';

interface DownloadTagsCsvProps {
  items: TagRow[];
  label: string;
  columns: { field: string; headerName: string; showSortIcon?: boolean }[];
}

export const DownloadTagsCsv = ({ items, label, columns }: DownloadTagsCsvProps) => {
  const crmOrg = useSelector(selectDefaultCreationEnvironment);

  const biEventProps = {
    numberOfRecords: items?.length ?? 0,
    exportType: label ?? '',
  };

  const csvHeaders = getCsvHeaders(columns);
  const translatedRows = items.map((item) => ({
    ...item,
    name: item._name,
  }));

  return (
    <DownloadAsCsvButton
      fileName={`${crmOrg?.name}_${label}_Export_from_Sweep`}
      headers={csvHeaders}
      rows={translatedRows}
      withButtonLabel
      biEventProps={biEventProps}
    />
  );
};
